import { useEffect, useRef } from "react";
import { useAuth } from "./AuthContext";
import { usuarioDonoPlataforma } from "../utils/permissoes";
import { dentroDaJanela, msAteFecharJanela } from "../utils/janelaHorario";
import { CHAVE_MENSAGEM_SESSAO, guardarMensagemSessao } from "./mensagemSessao";

export { CHAVE_MENSAGEM_SESSAO };
const MENSAGEM_EXPIRACAO = "Sua sessão foi encerrada: fora do horário de acesso permitido para o seu perfil.";
const INTERVALO_VERIFICACAO_MS = 60_000;
const MAX_SET_TIMEOUT_MS = 0x7fffffff;

/**
 * Encerra a sessão sozinha quando o horário permitido pelo perfil do login
 * termina enquanto o usuário está com o sistema em uso — grava o motivo para
 * a tela de login exibir e força um reload real (não só navegação client-side).
 */
export function useJanelaHorarioWatcher() {
  const { usuario, sair } = useAuth();
  const encerrandoRef = useRef(false);

  useEffect(() => {
    if (!usuario || usuarioDonoPlataforma(usuario)) return;
    if (!usuario.horarioInicio && !usuario.horarioFim) return;

    const janela = {
      horarioInicio: usuario.horarioInicio,
      horarioFim: usuario.horarioFim,
      diasSemana: usuario.diasSemana,
    };

    function encerrarPorHorario() {
      if (encerrandoRef.current) return;
      encerrandoRef.current = true;
      guardarMensagemSessao(MENSAGEM_EXPIRACAO);
      void sair().finally(() => {
        window.location.assign("/login");
      });
    }

    function verificar() {
      if (!dentroDaJanela(janela)) encerrarPorHorario();
    }

    const restante = msAteFecharJanela(janela);
    const timeoutId = window.setTimeout(verificar, Math.min(restante ?? MAX_SET_TIMEOUT_MS, MAX_SET_TIMEOUT_MS));
    const intervalId = window.setInterval(verificar, INTERVALO_VERIFICACAO_MS);

    return () => {
      window.clearTimeout(timeoutId);
      window.clearInterval(intervalId);
    };
  }, [usuario, sair]);
}
